import {
  Box,
  Button,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import React from 'react';
import { downloadReport } from 'src/utils/downloadUtils';

const ViewDocsResult = (props) => {

  return (
    <>
      <Grid xs item>
        <Card elevation={0} sx={{ mt: 2 }}>
          <Box>
            <TableContainer>
              <Table>
                {!props.message ?
                  <>
                    <TableHead>
                      <TableRow>
                        <TableCell align='center'>Invoice</TableCell>
                        <TableCell align="center">Prescription</TableCell>
                        <TableCell align="center">Report</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell align='center'>
                          {props.invoiceUrl.length > 0 ?
                            props.invoiceUrl.map((url) => (
                              <div>
                                <Button style={{ backgroundColor: '#009efb', color: 'white', margin: '5px' }} onClick={() => downloadReport(url)}>
                                  Download Invoice
                                </Button>
                              </div>
                            )) : null}
                        </TableCell>
                        <TableCell align="center">
                          {props.prescriptionUrl.length > 0 ?
                            props.prescriptionUrl.map((url) => (
                              <div>
                                <Button style={{ backgroundColor: '#009efb', color: 'white', margin: '5px' }} onClick={() => downloadReport(url)}>
                                  Download Prescription
                                </Button>
                              </div>
                            )) : null}
                        </TableCell>
                        <TableCell align="center">
                          {props.reportUrl.length > 0 ?
                            props.reportUrl.map((url) => (
                              <div>
                                <Button style={{ backgroundColor: '#009efb', color: 'white', margin: '5px' }} onClick={() => downloadReport(url)}>
                                  Download report
                                </Button>
                              </div>
                            )) : null}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </> : (
                    <TableBody>
                      <TableRow align="center" style={{ fontStyle: "arial", color: 'red' }} colSpan={3}><h3>{props.message}</h3></TableRow>
                    </TableBody>
                  )
                }
              </Table>
            </TableContainer>
          </Box>
        </Card>
      </Grid>
    </>
  );
};

export default ViewDocsResult;
